
import { Component, ViewEncapsulation, ViewChild, ChangeDetectorRef, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SAUTableModule } from '@some-angular-utils/table';
import { SAUModalService } from '@some-angular-utils/modal';
import { Urls } from '../../../apiConnection/urls';
import { CustomDeleteComponent } from '../../../components/custom-delete/custom-delete.component';
import { InvoiceTemplateComponent } from '../invoice-template/document.component';
import { AddButtonComponent } from '@/components/add-button/add-button.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ApiService } from '@/apiConnection/ApiService';
import { AuthenticationService } from '@/apiConnection/authentication.service';
import { DocumentReportCellsComponent } from '@/components/document-report-cells/document-report-cells.component';

@Component({
  imports: [
    RouterModule,
    SAUTableModule,
    AddButtonComponent,
    ReactiveFormsModule,
    DocumentReportCellsComponent,
  ],
  templateUrl: './documents-list.page.html',
  styleUrl: './documents-list.page.scss',
  encapsulation: ViewEncapsulation.None
})


export class DocumentListInvoicesPage {

  @ViewChild(InvoiceTemplateComponent)
  InvoiceTemplateComponent!: InvoiceTemplateComponent;

  @ViewChild('sauTable')
  sauTable: { refresh: () => void; getItems: () => void; } | undefined;

  private sauModalService = inject(SAUModalService);

  loading = false;
  printing = false;
  orientation: "dynamic" | "horizontal" | "vertical" = 'dynamic'
  showOptions = true
  limitNumber = 10

  public url = Urls.urls.documents;

  public headers = [
    { name: 'Número', key: 'type' },
    { name: 'Cliente', key: 'client.name' },
    { name: 'Total', key: 'total' },
    { name: 'Fecha', key: 'date', type: 'date' },
    { name: 'Usuario', key: 'user.name' },
    { name: 'Relación', key: 'relations' },
  ];

  public headersWithoutRelations = this.headers.filter(h => h.key !== 'relations' && h.key !== 'user.name');

  public filterConfigBackup: any = null
  public filterConfig: any = {
    orderParamName: 'sort',
    orderByFields: [
      { field: 'created_at', label: 'Fecha' },
      { field: 'total', label: 'Total' },
    ],
    order: ['dateRange', 'client', 'category', 'product'],
    mobile: ['dateRange'],
    form: {
      type: {
        key: 'types',
        type: 'inputText',
        defaultValue: 'factura,devolucion'
      },
      dateRange: {
        name: 'Periodo',
        key: 'date_start',
        keyTo: 'date_end',
        type: 'dateRange',
        defaultValue: []
      },
      client: {
        name: 'Cliente',
        key: 'client_id',
        type: 'selectSimple',
        dropdowns: [],
      },
      category: {
        name: 'Familia',
        key: 'category_id',
        type: 'selectMultiple',
        dropdowns: [],
      },
      product: {
        name: 'Producto',
        key: 'products',
        type: 'selectSimple',
        dropdowns: [],
      },
    }
  };


  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef,
    private apiService: ApiService,
    private authService: AuthenticationService,
  ) { }

  canShowDocType(docType: string): boolean {
    const allowed = this.authService.getAllowedDocumentTypes();
    return allowed === null || allowed.includes(docType);
  }

  showEditAndDeleteButtons(item: { type: string, document_ref: number, status: string }): boolean {
    if (item.type === 'albaran' && item.document_ref != null) return false;
    if (item.status === 'draft') return true;
    return (item.type == 'albaran' || item.type == 'presupuesto') && item.document_ref == null;
  }

  showPrintButton(item: { status: string }): boolean {
    return item.status === null;
  }

  print(item: { id: number }) {
    window.open(`/invoice/print/${item.id}`, '_blank');
  }

  showDetails(item: { id: number }) {
    window.open(`/sales-reports/view/${item.id}`, '_blank');
  }

  toggleEditForm(item: { id: number }) {
    this.router.navigate(['/sales-reports/edit', item.id]);
  }

  openDeleteForm(item: { id: number } = { id: 0 }) {
    const modalRef = this.sauModalService.open(CustomDeleteComponent, {});
    modalRef.componentInstance.id = item.id;
    modalRef.componentInstance.url = this.url;
    modalRef.componentInstance.item = 'documento';

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }
  ngOnInit(): void {
    this.getDropdowns();
  }

  public dropdowns: any = {
    clients: [],
    products: [],
    categories: [],
  };

  onSubmit(): void {

    this.cdr.detectChanges();
    this.sauTable?.refresh();

  }

  getDropdowns() {
    const config = { clients: {}, products: {}, categories: {} };
    this.apiService.getSelectors(Urls.urls.selectors, config).subscribe({
      next: (data: any) => {
        this.dropdowns.categories = data.categories || [];
        this.dropdowns.clients = data.clients || [];
        this.dropdowns.products = data.products || [];

        this.filterConfig.form.category.dropdowns.push(...data.categories || [])
        this.filterConfig.form.client.dropdowns.push(...data.clients || [])
        this.filterConfig.form.product.dropdowns.push(...data.products || [])

        this.cdr.detectChanges();
      }
    });
  }

  printReport() {
    if (this.printing) return;
    this.printing = true;

    this.filterConfigBackup = this.filterConfig

    this.orientation = 'horizontal'
    this.showOptions = false
    this.filterConfig = null
    this.limitNumber = 9999999
    this.cdr.detectChanges();
    this.sauTable?.refresh();

  }

  finishLoad(event: any) {
    if (this.printing) {
      window.print(); // this will stop automatically

      this.orientation = 'dynamic'
      this.showOptions = true
      this.filterConfig = this.filterConfigBackup
      this.limitNumber = 10
      this.printing = false;
      this.cdr.detectChanges();
      this.sauTable?.refresh();
    }
  }

}
